<div class="row">
  <div class="col-12 col-lg-6">
    <div class="kt-portlet kt-portlet--tab">
      <div class="kt-portlet__body">
        <zxing-scanner [(device)]="device" (camerasFound)="camerasFound($event)"
                       (scanSuccess)="scanSuccessHandler($event)">
        </zxing-scanner>
      </div>
    </div>
  </div>

  <div class="info-popup">
    <p class="kt-callout__desc">
      {{information}}
    </p>
  </div>

</div>
